import React from 'react'

function index() {
  return (
    <div>
      <h1>I am setting compoentn</h1>
    </div>
  )
}

export default index
